import { detectFileType } from '@orijinworks/frontend-commons';
import { getAttachmentDownloadUrl } from '../services/Feed.service';

/**
 * Fetches a presigned URL for feeds attachment preview (announcements, All Feeds, drawer, etc.).
 */
export async function fetchFeedAttachmentPreview(attachment) {
  const attachmentId =
    attachment?.id ?? attachment?.attachmentId ?? attachment?.fileId;
  if (!attachmentId) {
    throw new Error('Attachment id is required');
  }
  const response = await getAttachmentDownloadUrl(attachmentId);
  const url =
    response?.data?.presignedUrl ?? response?.data?.url ?? response?.data?.downloadUrl;
  if (!url) {
    throw new Error('URL not found in response');
  }
  return {
    url,
    fileName: attachment.filename ?? attachment.fileName ?? '',
    fileType: detectFileType(
      attachment.filename || attachment.fileName || attachment.mimeType || '',
    ),
  };
}
